// extracted by mini-css-extract-plugin
export default {"page":"Homepage_page__c0wwr","main-container":"Homepage_main-container__wopZV"};